import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["email", "password"]

  fill(event) {
    const button = event.currentTarget
    const email = button.dataset.email
    const password = button.dataset.password

    this.emailTarget.value = email
    this.passwordTarget.value = password

    // Dev shortcut: filling the credentials and then tapping Sign in is two
    // taps for something used dozens of times a day, so submit right away.
    // requestSubmit (not submit) so Turbo still handles the navigation.
    this.emailTarget.form?.requestSubmit()
  }
}
